import { Component, OnInit, Input } from '@angular/core';
import { UtilService } from 'src/app/util/util.service';
import { DINNER } from 'src/defaultImages.js';
@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.css'],
})
export class OrderListComponent implements OnInit {
  images = { 
    DINNER: DINNER,
  };
  @Input() items: any;
  constructor(public utilService: UtilService) {}
  ngOnInit() {
  }
}
